export const USER_ACTIONS = {
  SET_LOADING: "SET_LOADING",
  SET_USERS: "SET_USERS",
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  SET_ERROR: "SET_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  SET_SELECTED_USER: "SET_SELECTED_USER",
  RESET_STATE: "RESET_STATE",
};

const initialState = {
  users: [],
  loading: false,
  error: null,
  selectedUser: null,
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case USER_ACTIONS.SET_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false,
        error: null,
      };

    case USER_ACTIONS.ADD_USER:
      return {
        ...state,
        users: [...state.users, action.payload],
        loading: false,
        error: null,
      };

    case USER_ACTIONS.UPDATE_USER:
      return {
        ...state,
        users: state.users.map(user => (user.email === action.payload.email ? action.payload : user)),
        loading: false,
        error: null,
      };

    case USER_ACTIONS.DELETE_USER:
      return {
        ...state,
        users: state.users.filter(user => user.email !== action.payload),
        loading: false,
        error: null,
      };

    case USER_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case USER_ACTIONS.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case USER_ACTIONS.SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: action.payload,
      };

    case USER_ACTIONS.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default userReducer;
